import type { ReactNode } from "react";
import PageIntro from "@/components/marketing/PageIntro";
import { cn } from "@/lib/utils";

export default function ToolLookupCard({
  title,
  description,
  children,
  className,
}: {
  title: string;
  description: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "service-mesh-surface overflow-hidden rounded-2xl p-6 md:p-8",
        className,
      )}
    >
      <PageIntro
        title={title}
        description={description}
        titleAs="h1"
        className="mb-6"
      />
      {children}
    </div>
  );
}
